export default "__VITE_ASSET__Bp8RVQ0X__"